<article class="ul-card">
  @if (this.userData(); as userData) {
    @if (userData.userData) {
      <h1>{{ 'forbidden.invitation.headline' | translate }}</h1>

      <p>{{ 'forbidden.invitation.text' | translate }}</p>
      <button comp-button="secondary" (click)="accountRequest()" type="button">
        <i comp-icon>person_add</i>
        <span>{{ 'forbidden.accountRequest.action' | translate }}</span>
      </button>

      <p>{{ 'forbidden.data.headline' | translate }}</p>
      <ul>
        <li>{{ 'forbidden.data.user' | translate: { userId: userData.userData.objectId } }}</li>
        @if (userData.userData.org !== undefined) {
          <li>{{ 'forbidden.data.org' | translate: { orgId: userData.userData.org } }}</li>
        } @else {
          <li>{{ 'forbidden.data.noOrg' | translate }}</li>
        }
      </ul>
    } @else {
      <h1>{{ 'forbidden.headline' | translate }}</h1>
      <p>{{ 'forbidden.text' | translate }}</p>
    }
  } @else {
    <h1>{{ 'forbidden.headline' | translate }}</h1>
    <p>{{ 'forbidden.text' | translate }}</p>
  }
</article>
